import * as React from "react";
function SvgTriangleUp(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M0 24L16 8l16 16z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTriangleUp);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
